export function xJsonPath(data: any, path: string[]): any {
  if (data) {
    let temp = {};
    let result = data;
    let canContinue = true;
    for (const item of path) {
      if (canContinue) {
        temp = result[item];
        result = temp;
        if (!temp) {
          canContinue = false;
          result = null;
        }
      }
    }
    return result;
  } else {
    return null;
  }
}
